import type React from 'react';

import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { AIPromptStep } from './components/AIPromptStep';

async function loadAIPromptStep(): Promise<typeof AIPromptStep> {
	return (await import(/* webpackChunkName: "pages/start-a-petition-steps-ai-prompt" */ './components/AIPromptStep'))
		.AIPromptStep;
}

export const AIPromptLoader: React.FC = () => {
	return (
		<LazyComponent
			loadComponent={loadAIPromptStep}
			fallback={
				<Box margin="auto">
					<Loader />
				</Box>
			}
		/>
	);
};

export const preloadAIPromptStep = loadAIPromptStep;
